import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  startTaskIntegrationSession,
  type StartTaskIntegrationSessionParams,
  type TaskIntegrationSessionStatus,
} from '@services/TasksService';

export type UsePostTaskIntegrationSessionStartParams = {
  mutationOptions?: SWRMutationConfiguration<
    TaskIntegrationSessionStatus,
    unknown,
    string,
    StartTaskIntegrationSessionParams,
    TaskIntegrationSessionStatus
  >;
};

export const postTaskIntegrationSessionStartMutationKey =
  'post-task-integration-session-start';

export const usePostTaskIntegrationSessionStart = ({
  mutationOptions,
}: UsePostTaskIntegrationSessionStartParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    TaskIntegrationSessionStatus,
    unknown,
    string,
    StartTaskIntegrationSessionParams
  >(
    postTaskIntegrationSessionStartMutationKey,
    (_url, { arg }) => startTaskIntegrationSession(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
